import { makeid } from 'utils/helpers/makeid';

import {
  additionalFollowUpItem,
  freeTextCommentsItem,
  isPatientCROorDNCItem,
  needEscalateItem,
  twoWaySyncInfoItem,
  uniqueDaysItem,
} from '../common';

import type { TFormItem } from '../../types';

export const weight: TFormItem[] = [
  {
    key: makeid(10),
    title: <p>What is the reason for weight monitoring for this patient?</p>,
    type: 'radio',
    required: false,
    name: 'weightReason',
    options: [
      {
        label: 'Congestive Heart Failure (CHF)',
        value: 'Congestive Heart Failure (CHF)',
        key: makeid(10),
      },
      { label: 'Renal Disease', value: 'Renal Disease', key: makeid(10) },
      {
        label: 'Weight Management',
        value: 'Weight Management',
        key: makeid(10),
      },
      {
        label: 'Other (please specify in free text field)',
        value: 'other',
        key: makeid(10),
      },
    ],
    items: [
      {
        key: makeid(10),
        type: 'textarea',
        name: 'weightReasonComment',
        title: null,
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Is the patient awaiting any device replacements, troubleshooting or
        supplies?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'waitingDeviceReplacement',
    options: [
      {
        label: 'Yes',
        value: true,
        key: makeid(10),
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            type: 'checkbox',
            name: 'waitingForDeviceReplacementList',
            title: null,
            key: makeid(10),
            options: [
              {
                label: 'device replacement',
                value: 'device replacement',
                key: makeid(10),
              },
              {
                label: 'troubleshooting',
                value: 'troubleshooting',
                key: makeid(10),
              },
              { label: 'supplies', value: 'supplies', key: makeid(10) },
            ],
          },
        ],
      },
      {
        label:
          'No (describe in freetext; provide patient assistance if possible)',
        value: false,
        key: makeid(10),
        subItems: [
          {
            type: 'textarea',
            name: 'waitingForDeviceReplacementComment',
            title: null,
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Did the patient report any difficulties with weight readings (scale,
        display error, battery, etc.)?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'didPatientReportWeight',
    options: [
      {
        label:
          'Yes (describe in freetext; provide patient assistance if possible)',
        value: true,
        key: makeid(10),
      },
      { label: 'No', value: false, key: makeid(10) },
    ],
    items: [
      {
        type: 'textarea',
        name: 'didPatientReportWeightComment',
        title: null,
        key: makeid(10),
      },
    ],
  },
  {
    key: makeid(10),
    title: null,
    type: 'empty',
    name: '_empty',
    items: [
      {
        key: makeid(10),
        title: (
          <p>
            Number of at-risk weight readings in the last 7 days:{' '}
            <span>__</span>
          </p>
        ),
        type: 'input-number',
        required: false,
        name: 'atRiskNumber',
        validation: { min: 0 },
      },
      {
        key: makeid(10),
        title: (
          <p>
            Highest weight value: <span>__ lbs/kg</span>
          </p>
        ),
        type: 'input-number',
        required: false,
        name: 'highestWeight',
        validation: { min: 0 },
      },
      {
        key: makeid(10),
        title: (
          <p>
            Lowest weight value: <span>__ lbs/kg</span>
          </p>
        ),
        type: 'input-number',
        required: false,
        name: 'lowestWeight',
        validation: { min: 0 },
      },
    ],
  },
  {
    key: makeid(10),
    title: <p>What type of at-risk trend(s) were observed?</p>,
    type: 'radio',
    name: 'typeofTrend',
    options: [
      {
        label: 'High readings',
        value: 'high',
        key: makeid(10),
      },
      {
        label: 'Low readings',
        value: 'low',
        key: makeid(10),
      },
      {
        label: 'Both',
        value: 'both',
        key: makeid(10),
      },
      {
        label: 'Other trend (describe in free text)',
        value: 'other',
        key: makeid(10),
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            type: 'input',
            name: 'otherTypeofTrend',
            title: null,
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: <p>Compared to the past 30 days, have at-risk readings:</p>,
    type: 'radio',
    required: false,
    name: 'comparedToLastReview',
    options: [
      { label: 'Increased', value: 'increased', key: makeid(10) },
      { label: 'Decreased', value: 'decreased', key: makeid(10) },
      {
        label: 'Remained about the same',
        value: 'remained about the same',
        key: makeid(10),
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Has the number or trend of at-risk readings changed compared to the last
        review?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'comparedToLastReviewTrend',
    options: [
      { label: 'Trend improving', value: 'improving', key: makeid(10) },
      { label: 'Trend worsening', value: 'worsening', key: makeid(10) },
      {
        label: 'No significant change',
        value: 'about the same',
        key: makeid(10),
      },
    ],
  },
  { ...uniqueDaysItem('weight') },
  { ...twoWaySyncInfoItem },
  { ...isPatientCROorDNCItem },
  { ...additionalFollowUpItem },
  { ...needEscalateItem },
  { ...freeTextCommentsItem },
];
